export default __webpack_public_path__ + "static/wrench_b.b52c1cba0f89b08bc7e226775a92bebf.png";